import { Component, Input, OnInit } from '@angular/core';
import { ModalButton } from '../_classes/button';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dc-confirm',
  templateUrl: './confirm.component.html'
})
export class DCConfirmComponent implements OnInit {
  @Input() type: 'default' | 'danger' | 'warning';
  @Input() title: string = '';
  @Input() body: string;
  @Input() buttons: ModalButton[];
  @Input() showTitle: boolean = true;
  @Input() size: 'small' | 'medium' | 'large' | 'extra-large' = 'small';

  constructor(
      public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    if (this.title === '') {this.showTitle = false; }
  }

  close() {
    this.activeModal.dismiss();
  }

  onClick(button) {
    if (button.role === 'cancel') {
      this.activeModal.dismiss();
    }
    if (button.role !== 'cancel') {
      this.activeModal.close(button.role);
    }
    if (button.handler) {
      button.handler();
      this.activeModal.close();
    }
  }

}
